module.exports = __webpack_public_path__ + "static/media/Somany_Bath_Fittings_2016_Bathroom_of_your_Dreams.8adb1130.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/Somany_Bath_Fittings_2016_Bathroom_of_your_Dreams.gif
// module id = 348
// module chunks = 0